import { render, staticRenderFns } from "./PosSendToTerminal.vue?vue&type=template&id=2e23ce2c"
import script from "./PosSendToTerminal.vue?vue&type=script&lang=js"
export * from "./PosSendToTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports